/** The Staff page title, which doubles as the load indicator. */
import { Loader2 } from 'lucide-react';

export default function StaffPageHeader({ loading }: { loading: boolean }) {
  return (
    <div className="bg-white dark:bg-[#1a1f1c] border-b">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-bark-900 dark:text-[#e8ece9]">Staff</h1>
            <p className="text-sm text-stone-600 dark:text-stone-400 mt-1">
              {loading ? (
                <span className="flex items-center gap-1.5">
                  <Loader2 size={12} className="animate-spin" /> Loading staff...
                </span>
              ) : (
                'Manage teachers, assistants, and pay rates'
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
